module.exports = __webpack_public_path__ + "img/rulai.e478e855.jpeg";